import { Link } from "react-router-dom";

export default function FooterHome({ showPublicLinks = false }){
    const currentYear = new Date().getFullYear();
    return(
        <footer className="mt-auto w-full px-4 py-6 text-center">
            <p className="text-sm text-slate-600 tv:text-xl">© {currentYear} StunM. All rights reserved.</p>
            <nav className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2" aria-label="Footer navigation">
                {showPublicLinks && <Link to="/signup?tab=signup" className="text-sm text-blue-700 underline hover:text-blue-900">Plan your campaigns</Link>}
                {showPublicLinks && <Link to="/become-consultant" className="text-sm text-blue-700 underline hover:text-blue-900">Become a consultant</Link>}
                <Link to="/privacy-policy" className="text-sm text-blue-700 underline hover:text-blue-900">Privacy Policy</Link>
                <Link to="/terms-of-service" className="text-sm text-blue-700 underline hover:text-blue-900">Terms of Service</Link>
                <Link to="/meta-data-deletion" className="text-sm text-blue-700 underline hover:text-blue-900">Facebook and LinkedIn Data Deletion</Link>
            </nav>
        </footer>
    )
}
